import { render, staticRenderFns } from "./HorizontalScroller.vue?vue&type=template&id=1b16157e&scoped=true"
import script from "./HorizontalScroller.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalScroller.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HorizontalScroller.vue?vue&type=style&index=0&id=1b16157e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.1__lodash@4_56aa1e7e5d1d518316f437ffcea05512/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16157e",
  null
  
)

export default component.exports